import TextTitleLight from 'components/TextTitleLight'
import {
  STYLES_FONT_SIZE,
  STYLES_MARGIN
} from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import isHolidayDateUtil from 'containers/HolidayDelays/utils/is-holiday/index.js'
import { formatRelativeWithoutTimeDateUtil } from 'packages/src'
import { HOLIDAY_END_DATE } from 'containers/HolidayDelays/constants/index.js'

const messages = defineMessages({
  holidayDelays: {
    id: 'HolidayDelays.holidayDelays',
    defaultMessage: 'We’re on holidays. If you place an order now, it will get shipped on {endDate}.'
  }
})

export default function HolidayDelays () {
  const intl = useIntl()
  if (!isHolidayDateUtil()) {
    return <></>
  }

  return (
    <TextTitleLight
      style={{
        fontSize: STYLES_FONT_SIZE.BODY_SMALL,
        marginTop: STYLES_MARGIN.SMALL
      }}
    >
      {
        formatMessageIntlUtil(intl, messages.holidayDelays, {
          endDate: formatRelativeWithoutTimeDateUtil(HOLIDAY_END_DATE)
        })
      }
    </TextTitleLight>
  )
}
